import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9cd2fecc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd2fecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cd2fecc')) {
      api.createRecord('9cd2fecc', component.options)
    } else {
      api.reload('9cd2fecc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9cd2fecc&scoped=true", function () {
      api.rerender('9cd2fecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/StockRecovery/index.vue"
export default component.exports